import { Postrequestcall } from "./request/Postrequest";
import { UPDATE_NOTIFICATION_STATUS } from "./constant/Apipath";

export const notificationApi = async (msgId, loginData) => {  
  const obj = {
      NotificationMessageId: msgId,
      ReceiverUserDevice: loginData?.userInformation?.DeviceId,
    };
    const res = await Postrequestcall(UPDATE_NOTIFICATION_STATUS, obj, loginData?.accessToken);  
};
